/**
 * The standing notice on every Base-solution output (CLAUDE.md §9.6b): AI
 * output is decision support that requires human review. The machine
 * translation variant carries the translation-specific wording.
 */

import { Alert } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

export const ADVISORY_TEXT =
  "AI-generated decision support — requires human review. Not a controlled record.";
export const MACHINE_TRANSLATION_TEXT =
  "Machine translation — requires human review before regulatory use.";

interface Props {
  variant?: "ai" | "machine-translation";
}

export function AdvisoryBanner({ variant = "ai" }: Props) {
  return (
    <Alert
      color="yellow"
      variant="light"
      icon={<IconAlertTriangle size={16} />}
      data-testid="advisory-banner"
    >
      {variant === "machine-translation" ? MACHINE_TRANSLATION_TEXT : ADVISORY_TEXT}
    </Alert>
  );
}
